import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrivetrainSchematicAdapted } from './drivetrain-schematic-block.adapter';

@Component({
  selector: 'ds-drivetrain-schematic-block',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './drivetrain-schematic-block.html',
  styleUrl: './drivetrain-schematic-block.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrivetrainSchematicBlockComponent {
  readonly data = input.required<DrivetrainSchematicAdapted>();

  readonly title = computed(() => this.data().title);
  readonly intro = computed(() => this.data().intro);
  readonly callout = computed(() => this.data().callout);
  readonly blocks = computed(() => this.data().blocks);
  readonly legend = computed(() => this.data().legend);
}
